import { render, staticRenderFns } from "./DynamicTemplateAdapter.vue?vue&type=template&id=219b80d6&scoped=true&"
import script from "./DynamicTemplateAdapter.vue?vue&type=script&lang=ts&"
export * from "./DynamicTemplateAdapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219b80d6",
  null
  
)

export default component.exports